import { useSyncExternalStore } from "react";

/** Reactively tracks the viewport's width in CSS pixels. */
export function useViewportWidth(): number {
  return useSyncExternalStore(
    (onStoreChange) => {
      window.addEventListener("resize", onStoreChange);
      return () => window.removeEventListener("resize", onStoreChange);
    },
    () => window.innerWidth,
    () => 0,
  );
}
